import { useState } from 'react';

const testimonials = [
  {
    name: 'Aisha Okonkwo',
    role: 'Parent of 3rd Grader',
    score: 'Math grade jumped from D to A',
    text: 'My son was falling behind in 3rd grade math — he couldn\'t grasp multiplication at all. After just 6 weeks with Mr. Augustine\'s materials, he not only caught up but became the top student in his class. I cried happy tears at his report card.',
    rating: 5,
    tag: 'Elementary',
    image: 'https://public.readdy.ai/ai/img_res/4e0cf23385b808578be06380d869d9fd.jpg',
  },
  {
    name: 'Carlos Mendoza',
    role: '8th Grade Student',
    score: 'NY State Test: 4 (top score)',
    text: 'I was really nervous about the 8th grade state math test. Mr. A\'s practice exams were almost exactly like the real thing. I scored a 4 — the highest level — and my teacher said I was one of only three kids in the school to do that.',
    rating: 5,
    tag: 'Grade 8 State Test',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20Latino%20teenage%20boy%20in%20a%20bright%20school%20hallway%2C%20backpack%20on%20shoulder%2C%20happy%20and%20proud%20academic%20achievement%20expression&width=400&height=400&seq=t-carlos-002&orientation=squarish',
  },
  {
    name: 'Priya Nair',
    role: 'SAT Student, Grade 11',
    score: 'SAT Math: 680 → 790',
    text: 'I had taken the SAT twice and was stuck at 680. Mr. Augustine identified exactly where I was losing points — mostly careless errors on algebra and data analysis. After his targeted drills, I hit 790 on my third attempt. Stanford here I come!',
    rating: 5,
    tag: 'SAT',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20Indian-American%20teenage%20girl%20in%20a%20bright%20modern%20library%2C%20books%20on%20table%2C%20academic%20success%20atmosphere%2C%20natural%20lighting&width=400&height=400&seq=t-priya-003&orientation=squarish',
  },
  {
    name: 'James Osei',
    role: 'Algebra Regents Student',
    score: 'Regents Score: 58 → 91',
    text: 'I failed the Algebra Regents the first time with a 58. I was embarrassed and didn\'t know what to do. Mr. Augustine\'s open-ended practice and video explanations changed everything. I retook it and scored a 91. My family was so proud.',
    rating: 5,
    tag: 'Algebra Regents',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20proud%20smiling%20Ghanaian-American%20teenage%20boy%20in%20a%20bright%20classroom%20setting%2C%20academic%20achievement%2C%20natural%20lighting%2C%20warm%20expression&width=400&height=400&seq=t-james-004&orientation=squarish',
  },
  {
    name: 'Mei-Ling Huang',
    role: 'Parent of 6th Grader',
    score: 'Grade improved from C− to A−',
    text: 'My daughter was struggling with ratios and proportions in 6th grade. She\'s a hard worker but the concepts just weren\'t clicking. The lesson videos here explained things in a way her textbook never did. She finished the year with an A minus.',
    rating: 5,
    tag: 'Middle School',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20warm%20smiling%20Chinese-American%20mother%20in%20her%2040s%20in%20a%20bright%20home%20office%2C%20confident%20and%20caring%20expression%2C%20soft%20natural%20lighting&width=400&height=400&seq=t-meiling-005&orientation=squarish',
  },
  {
    name: 'Darius Washington',
    role: 'ACT Student, Grade 12',
    score: 'ACT Math: 21 → 33',
    text: 'I needed a 30+ on the ACT for my scholarship. I was at a 21 and felt hopeless. Mr. Augustine broke down every single topic — trig, functions, geometry — in a way that actually made sense. I scored a 33 and kept my scholarship. Life changing.',
    rating: 5,
    tag: 'ACT',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20African-American%20teenage%20boy%20in%20a%20bright%20modern%20school%20setting%2C%20proud%20expression%2C%20scholarship%20achievement%2C%20natural%20lighting&width=400&height=400&seq=t-darius-006&orientation=squarish',
  },
  {
    name: 'Sofia Petrov',
    role: 'Geometry Regents Student',
    score: 'Regents Score: 72 → 96',
    text: 'Geometry proofs were my nightmare. I could do the calculations but the logical reasoning part always tripped me up. The open-ended practice on this site with full rubrics showed me exactly how to write a proper proof. I scored a 96 on the Regents!',
    rating: 5,
    tag: 'Geometry Regents',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20Russian-American%20teenage%20girl%20in%20a%20bright%20modern%20classroom%2C%20happy%20academic%20success%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-sofia-007&orientation=squarish',
  },
  {
    name: 'Kwame Asante',
    role: 'Parent of 9th Grader',
    score: 'Algebra 1 final: F → B+',
    text: 'My son was failing Algebra 1 in 9th grade and his teacher suggested summer school. Instead, we found Mr. Augustine. He worked through every unit from scratch. By September he retook the final and passed with a B+. No summer school needed.',
    rating: 5,
    tag: 'Algebra 1',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20proud%20smiling%20Ghanaian-American%20father%20in%20his%2040s%20in%20a%20bright%20home%20setting%2C%20warm%20and%20confident%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-kwame-008&orientation=squarish',
  },
  {
    name: 'Isabela Ferreira',
    role: 'AP Calculus AB Student',
    score: 'AP Exam Score: 2 → 5',
    text: 'I scored a 2 on my first AP Calc AB practice exam and was ready to drop the class. The AP Calculus readiness quiz here showed me exactly which precalc gaps were holding me back. I fixed them, retook the full mock exam, and scored a 5 on the real AP exam.',
    rating: 5,
    tag: 'AP Calculus',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20Brazilian-American%20teenage%20girl%20in%20a%20bright%20university%20campus%20setting%2C%20academic%20excellence%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-isabela-009&orientation=squarish',
  },
  {
    name: 'Ethan Goldberg',
    role: 'GRE Student',
    score: 'GRE Quant: 152 → 169',
    text: 'I hadn\'t done serious math in 8 years when I started GRE prep. My first practice score was a 152. Mr. Augustine\'s structured approach — starting from algebra basics and building up — got me to a 169. I\'m now in a top-10 PhD program.',
    rating: 5,
    tag: 'GRE',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20Jewish-American%20young%20man%20in%20his%20late%2020s%20in%20a%20modern%20university%20library%2C%20graduate%20student%20success%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-ethan-010&orientation=squarish',
  },
  {
    name: 'Fatima Al-Rashid',
    role: '5th Grade Student',
    score: 'State Test: Below Basic → Proficient',
    text: 'Math was really hard for me and I used to cry before tests. My mom found Mr. Augustine\'s free lessons and we started with fractions. He explains everything so clearly and never makes you feel dumb. I passed my state test this year — I was so happy!',
    rating: 5,
    tag: 'Elementary',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20happy%20smiling%20Arab-American%20young%20girl%20around%2010%20years%20old%20in%20a%20bright%20colorful%20classroom%2C%20joyful%20learning%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-fatima-011&orientation=squarish',
  },
  {
    name: 'Marcus Delacroix',
    role: 'Algebra 2 Regents Student',
    score: 'Regents Score: 65 → 88',
    text: 'Algebra 2 Regents was the hardest test I\'d ever taken. Logarithms, trig, sequences — I was lost. The practice exams here with step-by-step solutions helped me understand the patterns. I went from a 65 to an 88 and finally feel confident in math.',
    rating: 5,
    tag: 'Algebra 2 Regents',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20Haitian-American%20teenage%20boy%20in%20a%20bright%20modern%20school%20hallway%2C%20proud%20academic%20achievement%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-marcus-012&orientation=squarish',
  },
  {
    name: 'Linda Kowalski',
    role: 'Parent of 7th Grader',
    score: 'Math anxiety resolved, grade A',
    text: 'My daughter had severe math anxiety — she would have panic attacks before tests. Mr. Augustine\'s calm, patient teaching style completely changed her relationship with math. She now volunteers to go to the board in class. Her grade is an A and her confidence is through the roof.',
    rating: 5,
    tag: 'Middle School',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20warm%20smiling%20Polish-American%20mother%20in%20her%2040s%20in%20a%20bright%20home%20setting%2C%20relieved%20and%20proud%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-linda-013&orientation=squarish',
  },
  {
    name: 'Ravi Krishnamurthy',
    role: 'GMAT Student',
    score: 'GMAT Quant: Q44 → Q51',
    text: 'I was scoring Q44 on GMAT quant and needed Q50+ for my target schools. The problem-solving frameworks Mr. Augustine teaches — especially for data sufficiency — are unlike anything I found elsewhere. I hit Q51 and got into Wharton.',
    rating: 5,
    tag: 'GMAT',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20Indian-American%20young%20professional%20man%20in%20his%20late%2020s%20in%20a%20modern%20office%20setting%2C%20MBA%20success%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-ravi-014&orientation=squarish',
  },
  {
    name: 'Aaliyah Brooks',
    role: 'Grade 10 Student',
    score: 'Geometry final: 54% → 91%',
    text: 'I was failing Geometry with a 54 average. Proofs, circles, coordinate geometry — none of it made sense. I used the Grade 10 lessons here every day for a month. My teacher couldn\'t believe the turnaround. I finished the year with a 91 and actually love geometry now.',
    rating: 5,
    tag: 'Geometry',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20African-American%20teenage%20girl%20in%20a%20bright%20modern%20classroom%2C%20academic%20turnaround%20success%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-aaliyah-015&orientation=squarish',
  },
  {
    name: 'Tomás Reyes',
    role: 'TX State Test (STAAR) Student',
    score: 'STAAR Math: Did Not Meet → Masters',
    text: 'I failed the STAAR test twice and was at risk of not advancing. My counselor recommended Mr. Augustine\'s TX practice exams. The questions were so similar to the real test. I went from "Did Not Meet" to "Masters" level — the highest category. I couldn\'t believe it.',
    rating: 5,
    tag: 'STAAR (TX)',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20proud%20smiling%20Mexican-American%20teenage%20boy%20in%20a%20bright%20Texas%20school%20setting%2C%20test%20success%20achievement%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-tomas-016&orientation=squarish',
  },
  {
    name: 'Yuki Tanaka',
    role: 'Parent of 4th Grader',
    score: 'Multiplication mastery in 3 weeks',
    text: 'My son was struggling with multiplication tables and his teacher said he might need to repeat 4th grade. We used Mr. Augustine\'s elementary lessons intensively for three weeks. He not only mastered multiplication but also division. He was promoted with flying colors.',
    rating: 5,
    tag: 'Elementary',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20warm%20smiling%20Japanese-American%20mother%20in%20her%2030s%20in%20a%20bright%20modern%20home%2C%20relieved%20and%20happy%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-yuki-017&orientation=squarish',
  },
  {
    name: 'Nadia Okafor',
    role: 'Precalculus Regents Student',
    score: 'Regents Score: 61 → 89',
    text: 'Precalculus Regents was intimidating — vectors, parametric equations, trig identities all in one exam. The open-ended practice here with full scoring rubrics was exactly what I needed. I knew what graders were looking for and scored an 89. My college application looks so much better now.',
    rating: 5,
    tag: 'Precalc Regents',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20Nigerian-American%20teenage%20girl%20in%20a%20bright%20modern%20school%20setting%2C%20proud%20Regents%20exam%20success%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-nadia-018&orientation=squarish',
  },
  {
    name: 'Samuel Abramowitz',
    role: 'Parent of 11th Grader',
    score: 'Algebra 2 grade: D → A−',
    text: 'My son was getting a D in Algebra 2 and his confidence was shattered. We tried two other tutors with no improvement. Mr. Augustine\'s approach is different — he finds the root of the misunderstanding and fixes it. Within two months my son had an A minus and was helping his classmates.',
    rating: 5,
    tag: 'Algebra 2',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20warm%20smiling%20Jewish-American%20father%20in%20his%2050s%20in%20a%20bright%20home%20office%2C%20proud%20and%20relieved%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-samuel-019&orientation=squarish',
  },
  {
    name: 'Amara Diallo',
    role: 'SAT & Algebra Regents Student',
    score: 'SAT: 1180 → 1430 | Regents: 94',
    text: 'I was preparing for both the SAT and the Algebra Regents at the same time — it was overwhelming. Mr. Augustine\'s materials overlap perfectly because the content is so well organized. I scored a 1430 on the SAT and a 94 on the Regents in the same month. Best investment my family ever made.',
    rating: 5,
    tag: 'SAT + Regents',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20Senegalese-American%20teenage%20girl%20in%20a%20bright%20modern%20library%2C%20dual%20exam%20success%20achievement%20expression%2C%20natural%20lighting&width=400&height=400&seq=t-amara-020&orientation=squarish',
  },
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [filter, setFilter] = useState('All');

  const tags = ['All', 'SAT', 'ACT', 'GRE', 'GMAT', 'AP Calculus', 'Regents', 'Elementary', 'Middle School'];

  const filtered = filter === 'All'
    ? testimonials
    : filter === 'Regents'
      ? testimonials.filter(t => t.tag.toLowerCase().includes('regents'))
      : testimonials.filter(t => t.tag === filter);

  const visible = filtered.slice(currentIndex, currentIndex + 3);
  const totalPages = Math.ceil(filtered.length / 3);
  const currentPage = Math.floor(currentIndex / 3);

  const nextSlide = () => {
    setCurrentIndex((prev) => {
      const next = prev + 3;
      return next >= filtered.length ? 0 : next;
    });
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => {
      const next = prev - 3;
      return next < 0 ? Math.floor((filtered.length - 1) / 3) * 3 : next;
    });
  };

  const handleFilterChange = (tag: string) => {
    setFilter(tag);
    setCurrentIndex(0);
  };

  return (
    <section id="testimonials" className="py-24 px-6 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-5xl md:text-6xl font-bold mb-5 text-gray-900">
            Success Stories
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-6">
            Real results from students and families across the USA — every grade level, every test
          </p>
          <div className="flex items-center justify-center gap-3 mb-2">
            <div className="flex gap-1">
              {[1,2,3,4,5].map(s => (
                <i key={s} className="ri-star-fill text-2xl text-amber-400"></i>
              ))}
            </div>
            <span className="text-2xl font-bold text-gray-900">4.9/5</span>
            <span className="text-gray-500 text-base">· 500+ reviews</span>
          </div>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {tags.map(tag => (
            <button
              key={tag}
              onClick={() => handleFilterChange(tag)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                filter === tag
                  ? 'bg-emerald-600 text-white shadow-md'
                  : 'bg-white text-gray-600 border border-gray-200 hover:border-emerald-400 hover:text-emerald-600'
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        {/* Cards Grid */}
        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 min-h-[420px]">
            {visible.map((t, i) => (
              <div
                key={`${t.name}-${i}`}
                className="bg-white rounded-2xl shadow-lg p-7 flex flex-col gap-4 border border-gray-100 hover:shadow-xl transition-shadow duration-300"
              >
                {/* Tag */}
                <span className="inline-block self-start px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs font-semibold tracking-wide">
                  {t.tag}
                </span>

                {/* Stars */}
                <div className="flex gap-1">
                  {[...Array(t.rating)].map((_, si) => (
                    <i key={si} className="ri-star-fill text-lg text-amber-400"></i>
                  ))}
                </div>

                {/* Quote */}
                <p className="text-gray-700 text-sm leading-relaxed flex-1 italic">
                  "{t.text}"
                </p>

                {/* Score badge */}
                <div className="bg-emerald-50 rounded-lg px-4 py-2 text-center">
                  <p className="text-emerald-700 font-semibold text-sm">{t.score}</p>
                </div>

                {/* Person */}
                <div className="flex items-center gap-3 pt-1 border-t border-gray-100">
                  <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 border-2 border-emerald-400">
                    <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-sm">{t.name}</p>
                    <p className="text-gray-500 text-xs">{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-6 mt-10">
            <button
              onClick={prevSlide}
              className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-emerald-500 hover:text-white transition-all duration-300 cursor-pointer border border-gray-200"
              aria-label="Previous"
            >
              <i className="ri-arrow-left-s-line text-2xl"></i>
            </button>

            <div className="flex gap-2">
              {Array.from({ length: totalPages }).map((_, pi) => (
                <button
                  key={pi}
                  onClick={() => setCurrentIndex(pi * 3)}
                  className={`h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                    pi === currentPage ? 'bg-emerald-600 w-8' : 'bg-gray-300 w-2.5'
                  }`}
                  aria-label={`Page ${pi + 1}`}
                />
              ))}
            </div>

            <button
              onClick={nextSlide}
              className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-emerald-500 hover:text-white transition-all duration-300 cursor-pointer border border-gray-200"
              aria-label="Next"
            >
              <i className="ri-arrow-right-s-line text-2xl"></i>
            </button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20 max-w-4xl mx-auto">
          <div className="text-center p-8 bg-white rounded-2xl shadow-lg">
            <div className="text-5xl font-bold text-emerald-600 mb-3">95%</div>
            <div className="text-lg text-gray-700">Students Show Significant Improvement</div>
          </div>
          <div className="text-center p-8 bg-white rounded-2xl shadow-lg">
            <div className="text-5xl font-bold text-emerald-600 mb-3">5,000+</div>
            <div className="text-lg text-gray-700">Students Successfully Taught</div>
          </div>
          <div className="text-center p-8 bg-white rounded-2xl shadow-lg">
            <div className="text-5xl font-bold text-emerald-600 mb-3">30+</div>
            <div className="text-lg text-gray-700">Years of Teaching Excellence</div>
          </div>
        </div>
      </div>
    </section>
  );
}
